export default __webpack_public_path__ + "static/media/interview.e6084291.png";